import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import filterChildren from "../../utils/Children/filterChildren";
import cn from "../../../utils/cn";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Tabs = _ref => {
  let {
    id = '',
    className = '',
    style = {},
    value,
    onChange,
    children = []
  } = _ref;
  const [content, setContent] = useState(null);
  const handleSetContent = useCallback(newContent => {
    setContent(newContent);
  }, []);
  const tabsClass = cn('relative', className);
  const newChildren = filterChildren(children, {
    onChange,
    setContent: handleSetContent,
    activeTab: value
  });
  return /*#__PURE__*/_jsxs("div", {
    id: id,
    className: tabsClass,
    style: style,
    children: [newChildren, content]
  });
};
Tabs.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /** selects the tab whose value prop matches this prop. */
  value: PropTypes.string.isRequired,
  /** Called when the selected value change. */
  onChange: PropTypes.func.isRequired,
  /** children props for content inside */
  children: PropTypes.node
};
export default Tabs;
//# sourceMappingURL=Tabs.js.map